import { boronClient } from "../../../../api";
import { useBoronMutation } from "../../../../hooks/http/useBoronMutation";
import { OperatorRoleTypes } from "../../../../interfaces/OperatorInterface";
import { useOperatorsCacheUpdater } from "../../useFetchOperators";

export const useChangeOperatorRole = () => {
  const { updateActiveOperator } = useOperatorsCacheUpdater();

  return useBoronMutation(
    async ({
      sectionId,
      operatorId,
      role,
    }: {
      sectionId: string;
      operatorId: string;
      role: OperatorRoleTypes;
    }) => {
      const endpoint =
        role === "admin"
          ? "/api/v1/sections/{section_id}/operators/{operator_hashid}/admin"
          : "/api/v1/sections/{section_id}/operators/{operator_hashid}/member";

      return await boronClient.PATCH(endpoint, {
        params: {
          path: {
            section_id: sectionId,
            operator_hashid: operatorId,
          },
        },
      });
    },
    {
      onSuccess: ({ activeOperator }, { sectionId }) => {
        updateActiveOperator(sectionId, activeOperator);
      },
    },
  );
};
